const createToasts = function (messages) {
    if (typeof messages === "undefined") {
        return;
    }
    messages.forEach(createToast);
}

const createToast = function (item) {
    const toast = $('<div class="toast fade ' + item[0] + ' hide" role="alert" data-bs-delay="3000" aria-live="assertive" aria-atomic="true">\n' +
        '            <div class="toast-header">\n' +
        '                <strong>' + item[1] + '</strong>\n' +
        '                <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>\n' +
        '            </div>\n' +
        '        </div>');
    $('.toast-container').append(toast);
    toast.toast('show');
    $(toast).on('hidden.bs.toast', function () {
        this.remove();
    });
}

const bind = function () {
    $('.toast').toast('show');
}

export {
    createToasts,
    createToast,
    bind
}
